import React, { useRef } from "react";
import ReactDOM from "react-dom";
import { observer } from "mobx-react";
import { useRootAppStore } from "@hooks";

import { useFixBody } from "@state/hooks/shared";
import { WebPlatform } from "@state/stores/types";

import { HeaderSuggestedSearchList } from "@components/header/desktop/components/search/HeaderSuggestedSearchList";

export default observer(function HeaderSuggestedSearchPopup() {
	const rootStore = useRootAppStore<WebPlatform>();
	const searchStore = rootStore.searchStore;

	const containerRef = useRef<HTMLDivElement>(null);

	useFixBody(true, searchStore.isSuggestedListOpen);

	if (!searchStore.isSuggestedListOpen) {
		return null;
	}

	return ReactDOM.createPortal(
		<div
			className="popup popup--search"
			onClick={() => {
				searchStore.setIsSuggestedListOpen(false);
			}}
		>
			<div className="popup__card popup--search__card" ref={containerRef}>
				<div className="popup__body popup--search__body">
					<HeaderSuggestedSearchList />
				</div>
			</div>
		</div>,
		document.body
	);
});
